<template>
  <div class="app-container">
    <van-cell-group title="绑定手机">
      <van-field
        v-model="phoneNumber"
        v-validate="{required:true,regex:/^[1][3455789][0-9]{9}$/}"
        name="phoneNumber"
        label="手机号"
        type="tel"
        size="large"
        required
        clearable
        placeholder="请输入手机号"
        data-vv-as="手机号"
      />
      <van-field
        v-model="verificationCode"
        v-validate="{required:true,numeric:true,length:4}"
        name="verificationCode"
        label="短信验证码"
        type="number"
        size="large"
        required
        center
        clearable
        placeholder="请输入短信验证码"
        data-vv-as="验证码"
      >
        <van-button
          slot="button"
          size="small"
          type="primary"
          :disabled="sendVerificationCodeDisabled"
          style="width:80px;"
          @click="handleSendVerificationCode"
        >
          {{ sendVerificationCodeText }}
        </van-button>
      </van-field>
    </van-cell-group>
    <div class="button-wrap">
      <van-button
        type="primary"
        size="large"
        :disabled="submitDisabled"
        @click="handleSubmit"
      >
        {{ submitText }}
      </van-button>
    </div>
  </div>
</template>

<script>
import { sendVerificationCode } from '@/api/sms'
import { Toast } from 'vant'

export default {
  data() {
    return {
      phoneNumber: '',
      verificationCode: '',
      verificationCodeCountDown: 0,
      isSendingVerificationCode: false,
      isSubmitting: false,
      isPhoneNumberValid: false,
      isFormValid: false
    }
  },
  computed: {
    verificationCodeExpiresIn() {
      return parseInt(process.env.VUE_APP_VERIFICATION_CODE_EXPIRES_IN)
    },
    sendVerificationCodeText() {
      if (this.isSendingVerificationCode) {
        return '发送中...'
      } else if (this.verificationCodeCountDown === 0) {
        return '发送验证码'
      } else {
        return this.verificationCodeCountDown
      }
    },
    submitText() {
      return this.isSubmitting ? '提交中...' : '提交'
    },
    sendVerificationCodeDisabled() {
      return !this.isPhoneNumberValid || this.isSendingVerificationCode || this.verificationCodeCountDown > 0
    },
    submitDisabled() {
      return !this.isFormValid || this.isSubmitting
    },
    validationErrors() {
      return this.$validator.errors
    },
    openId() {
      return this.$store.getters.weChatUserInfo.openId
    }
  },
  watch: {
    validationErrors: {
      handler(newValue, oldValue) {
        this.isPhoneNumberValid = !newValue.has('phoneNumber')
        this.isFormValid = !newValue.any()
      },
      deep: true
    }
  },
  mounted() {
    this.$validator.validateAll()
  },
  methods: {
    startCountDown() {
      // 设置验证码倒数值为默认过期时间
      this.verificationCodeCountDown = this.verificationCodeExpiresIn
      // 设置定时器，每秒减1
      let sendVerificationCodeInt = setInterval(() => {
        if (--this.verificationCodeCountDown === 0) {
          // 减到0时清除定时器
          clearInterval(sendVerificationCodeInt)
          sendVerificationCodeInt = null
        }
      }, 1000)
    },
    handleSendVerificationCode() {
      this.isSendingVerificationCode = true
      sendVerificationCode(this.phoneNumber).then(response => {
        this.startCountDown()
      }).catch(error => {
        // 提示异常
        const data = error.response.data
        if (data.message) {
          Toast.fail(data.message)
        }
      }).finally(() => {
        this.isSendingVerificationCode = false
      })
    },
    handleSubmit() {
      this.isSubmitting = true
      this.$store.dispatch('user/bindPhone', {
        phoneNumber: this.phoneNumber,
        verificationCode: this.verificationCode
      }).then(response => {
        // 绑定成功，重定向
        Toast.success({
          message: '绑定成功',
          onClose: () => {
            // 后退一步记录
            this.$router.go(-1)
          }
        })
      }).catch(error => {
        // 提示异常
        const data = error.response.data
        if (data.message) {
          Toast.fail(data.message)
        }
      }).finally(() => {
        this.isSubmitting = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.app-container{
  height: 100vh;
  background-color: #F8F8F8;
  .button-wrap{
    margin-top: 15px;
    padding: 0 15px;
  }
}
</style>
